export type PreviewArtifactUpload = {
  /** Authenticated, short-lived URL. Never a blob: URL. */
  url: string;
  expiresAt: string;
};

export type PreviewArtifactStore = {
  upload: (
    blob: Blob,
    options: { mimeType: string; ttlSeconds: number; fileName: string; signal?: AbortSignal },
  ) => Promise<PreviewArtifactUpload>;
};

let artifactStore: PreviewArtifactStore | null = null;

/** Large review videos are uploaded here. Without a store they return ARTIFACT_TOO_LARGE. */
export function registerPreviewArtifactStore(store: PreviewArtifactStore): () => void {
  artifactStore = store;
  return () => {
    if (artifactStore === store) {
      artifactStore = null;
    }
  };
}

export function getPreviewArtifactStore(): PreviewArtifactStore | null {
  return artifactStore;
}
